export default "__VITE_ASSET__f4b38b07__"